import React from 'react';
import { Splash } from './Splash';
import type { Athlete } from './athletes';
import type { Brand } from './brands';
import type { HeroRotationItem } from './heroRotation';
import type { JoinSectionData } from './joinSectionData';

type AppProps = {
    csrfToken: string;
    heroRotation: HeroRotationItem[];
    athletes: Athlete[];
    brandGrid: Brand[][];
    featuredHeading: string;
    featuredBody: string;
    joinSection: JoinSectionData;
};

export function App(props: AppProps) {
    return (
        <Splash
            csrfToken={props.csrfToken}
            heroRotation={props.heroRotation}
            athletes={props.athletes}
            brandGrid={props.brandGrid}
            featuredHeading={props.featuredHeading}
            featuredBody={props.featuredBody}
            joinSection={props.joinSection}
        />
    );
}
